<template>
    <div class="square-card">
        <div id="payment-form">
            <div id="payment-status-container"></div>
            <div id="card-container"></div>
            
            <div class="text-center" style="margin-top: 4em; margin-bottom: 4em;">
              <button :disabled="buttonDisabled" id="card-button" type="button" class="btn btn-dc"  >{{ buttonText }}</button>
            </div>
              
        </div>
    </div>
</template>
<script>
import * as Square from '@square/web-sdk';

export default {
    name: 'SquareCard',
    props: {
      environment: {
        type: String,
        required: true,
        default: 'sandbox'
      },
      applicationId: {
        type: String,
        required: true
      },
      accessToken: {
        type: String, 
        required: true
      },
      buttonText: {
        type: String,
        required: true,
        default: 'Pay'
      },
      buttonDisabled: {
        type: Boolean,
        required: true,
        default: false
      },
      beforeSubmit: {
        type: Function,
        required: true
      }
    },
    async created(){
       const config = {
            applicationId: this.applicationId,
            environment: this.environment,
            accessToken: this.accessToken,
        };
        this.squareClient = await Square.payments(config.applicationId);

        const cardContainer = window.document.getElementById('card-container');
        const cardButton = window.document.getElementById('card-button');

        this.CardPay(cardContainer, cardButton);
    },
    data(){
        return {
            squareClient: null,
        }
    },
    methods: {
      async CardPay(fieldEl, buttonEl) {
          // Create a card payment object and attach to page
          const card = await this.squareClient.card({
            style: {
              '.input-container.is-focus': {
                borderColor: '#006AFF'
              },
              '.message-text.is-error': {
                color: '#BF0020'
              }
            }
          });
          await card.attach(fieldEl);

          const eventHandler = async (event) => {
            // Clear any existing messages
            // window.paymentFlowMessageEl.innerText = '';

            try {
              const response = await this.beforeSubmit();

              const result = await card.tokenize();
              if (result.status === 'OK') {
                console.log(result);
                this.$emit('squareCardTokenCreated', result.token);
              }
            } catch (e) {
              if (e.message) {
                console.error(`Error: ${e.message}`);
              } else {
                console.error('Something went wrong');
              }
            }
          }

          buttonEl.addEventListener('click', eventHandler);
        }
    }
    
}
</script>